import { useState } from "react";
import { Col } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import { useWindowSize } from "react-use";
import NavPillTrack from "./navpills-components/NavPillTrack";
import NavPillTrackingCompany from "./navpills-components/NavPillTrackingCompany";
import "./navpills.css";
import QuickPriceF from "../quickPrice/quickPriceF";
import { FaLocationDot } from "react-icons/fa6";
import CityInquiry from "../../../pages/city/CityInquiry";

function NavPills() {
  const { width } = useWindowSize();
  const [navSelected, setNavSelected] = useState(1);

  const tabs = [
    { id: 1, label: "رهگیری مرسوله", icon: <Icon.Search /> },
    // { id: 2, label: "رهگیری مرسوله با بارکد", icon: <Icon.BoxSeam /> },
    {
      id: 3,
      label: "محاسبه سریع قیمت",
      icon: <Icon.CalculatorFill />,
    },
    {
      id: 4,
      label: "استعلام شهر",
      icon: <FaLocationDot />,
    },
  ];

  return (
    <section className="d-flex justify-content-center p-0 mx-2 mx-md-0">
      <Col
        md={10}
        lg={8}
        xl={7}
        xs={12}
        style={{ marginTop: width > 767 ? -74 : 30 }}
      >
        <Card
          className="rounded-0 shadow-lg px-3 py-4 mb-5 bg-body rounded"
          style={{
            marginBottom: 50,
            marginTop: 10,
            direction: "rtl",
          }}
        >
          <Card.Header className="bg-white">
            <Nav
              fill
              variant="tabs"
              className="justify-content-between"
              defaultActiveKey="#tracking"
            >
              {tabs.map(item => (
                <Nav.Item key={item.id}>
                  <Nav.Link
                    className={
                      "navpills border border-3 shadow  rounded-0 p-2 m-0 " +
                      (navSelected === item.id
                        ? "navpillsItemSelected"
                        : "navpillsItem")
                    }
                    onClick={() => {
                      setNavSelected(item.id);
                    }}
                  >
                    <span>{item.icon}</span>
                    <span className="me-2">{item.label}</span>
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Card.Header>

          <Card.Body className="py-3 px-2">
            {navSelected === 1 && <NavPillTrack />}
            {navSelected === 2 && <NavPillTrackingCompany />}
            {navSelected === 3 && <QuickPriceF />}
            {navSelected === 4 && <CityInquiry />}
          </Card.Body>
        </Card>
      </Col>
    </section>
  );
}

export default NavPills;
